<template>
  <v-form ref="cashiersForm">
    <v-row>
      <v-col cols="12" md="12">
        <p class="text-h6">Datos de movimiento</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-autocomplete
          v-model="Movimiento.Membresia"
          label="Membresia"
          :items="Membresias"
          item-text="Text"
          item-value="Id"
          :disabled="!!membresia"
          outlined
          dense
          required
        ></v-autocomplete>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-select
          v-model="Movimiento.Tipo"
          label="Tipo de Movimiento"
          :items="TiposMovimientos"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-select
          v-model="Movimiento.ConceptoCode"
          label="Concepto"
          :items="comp_conceptos"
          item-text="dscr"
          item-value="code"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col class="mt-n5" cols="12" md="6">
        <v-text-field
          v-model="Movimiento.Cantidad.C"
          type="number"
          label="Cantidad de movimiento"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
      <v-col class="mt-n5" cols="12" md="6">
        <v-select
          v-model="Movimiento.Cantidad.M"
          disabled
          :items="monedas"
          item-value="id"
          item-text="Nombre"
          label="Moneda"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="Movimiento.Fecha"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="Movimiento.Fecha"
              label="Fecha de pago"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="Movimiento.Fecha"
            no-title
            @input="$refs.menu.save(Movimiento.Fecha), (menu = false)"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu.save(Movimiento.Fecha)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="12" class="mt-n10">
        <p class="text-subtitle-1">Periodo:</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="6">
        <v-select
          v-model="mes"
          :items="meses"
          item-text="name"
          item-value="number"
          label="Mes"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col class="mt-n5" cols="12" md="6">
        <Datepicker
          :input-class="'v-input__control theme--light v-text-field dateinputClass '"
          :format="'yyyy'"
          :minimumView="'year'"
          :maximumView="'year'"
          v-model="year"
        ></Datepicker>
      </v-col>
      <v-col v-if="Movimiento.Tipo == 'P'" class="mt-n5" cols="12" md="12">
        <v-select
          v-model="Movimiento.MPago"
          label="Metodo de Pago"
          :items="metodosPago"
          item-value="id"
          item-text="Nombre"
          outlined
          dense
          required
        ></v-select>
      </v-col>
      <v-col
        class="mt-n5"
        v-if="
          Movimiento.Tipo == 'P' &&
          (Movimiento.MPago == 'AMEX' ||
            Movimiento.MPago == 'MACA' ||
            Movimiento.MPago == 'VISA' ||
            Movimiento.MPago == 'DMCL')
        "
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="Movimiento.NTransaccion"
          label="Numero de transacción"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Currency from "../../../clases/Currencies.js";
import MembresiasMovimientos from "../../../clases/Membresias/MembresiasMovimientos.js";
import MembresiaClass from "../../../clases/Membresias/Membresia.js";
import Cliente from "../../../clases/Cliente.js";
export default {
  name: "MovimientosForm",
  components: { Datepicker },
  props: ["edit", "dataEdit", "membresia"],
  data() {
    return {
      menu: false,
      currencyClass: Currency,
      monedas: [],
      Movimiento: MembresiasMovimientos.getPropertyModel(),
      Conceptos: [],
      mes: new moment().month() + 1,
      year: new moment().format("YYYY-MM-DD"),
      TiposMovimientos: [
        {
          text: "Pago",
          value: "P",
        },
        {
          text: "Cargo",
          value: "C",
        },
      ],
      conceptos: {},
      metodosPago: [],
      meses: [
        { name: "Enero", number: 1 },
        { name: "Febrero", number: 2 },
        { name: "Marzo", number: 3 },
        { name: "Abril", number: 4 },
        { name: "Mayo", number: 5 },
        { name: "Junio", number: 6 },
        { name: "Julio", number: 7 },
        { name: "Agosto", number: 8 },
        { name: "Septiembre", number: 9 },
        { name: "Octubre", number: 10 },
        { name: "Noviembre", number: 11 },
        { name: "Diciembre", number: 12 },
      ],
      rules: {
        Cve: [(value) => !!value || "La clave es obligatoria"],
        name: [(value) => !!value || "El Nombre es obligatorio"],
        CA: { C: [(value) => value >= 0 || "El costo anual es obligatorio"] },
        CPA: {
          C: [
            (value) => value >= 0 || "La comisión por apertura es obligatoria",
          ],
        },
        NM: [(value) => value >= 0 || "El numero de personas es requerido"],
        TIA: [(value) => value >= 0 || "La tasa de interes anual es requerida"],
      },
    };
  },
  computed: {
    Membresias() {
      let data_membresias = MembresiaClass.getMembresiasList();
      data_membresias.forEach((element) => {
        element.code = element?.Code?.Pre + "" + element?.Code?.Pos;
        //element.PlanName        = this.$pgsHelper.getById(this.PlanesMembresias,'Id',element.Plan).Nomb;
        let dataClient = this.$pgsHelper.getById(
          this.comp_clients,
          "id",
          element.Titular
        );
        element.TitularName = dataClient
          ? dataClient.Nombres + " " + dataClient.Apellidos
          : "Sin titular";
        element.Text = element.code + " - " + element.TitularName;
      });
      return data_membresias;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });
      return clientes;
    },
    comp_conceptos() {
      let array = [];
      let conc = Object.entries(this.conceptos);
      conc.forEach((concepto) => {
        array.push(concepto[1]);
      });
      return array;
    },
  },
  methods: {
    async getConceptos() {
      const database = this.$store.getters.getFirebaseApp.database;
      const ref = database.ref("MBS/Conceptos");
      const snapshot = await database.get(ref);
      if (!snapshot.exists()) {
        return false;
      }
      this.conceptos = snapshot.val();
    },
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.Movimiento;
      dataSave.Cantidad.C = Number(dataSave.Cantidad.C);
      dataSave.Concepto = this.conceptos[dataSave.ConceptoCode].dscr;
      dataSave.Periodo =
        moment(this.year).format("YYYY") + "-" + this.meses[this.mes - 1].name;
      if (dataSave.Tipo == "P") {
        let pagos = {};
        pagos[dataSave.MPago] = {
          Cantidad: dataSave.Cantidad,
          Referncia: dataSave.NTransaccion == "" ? null : dataSave.NTransaccion,
        };
        dataSave.Pagos = pagos;
      }
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      } else {
        delete dataSave.Id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    //localStorage.getItem("selectedDepartment");
    this.metodosPago = this.currencyClass.getPagos();
    this.getConceptos();
    this.monedas = this.currencyClass.getCurrencies();
    if (this.edit) {
      this.Movimiento = this.dataEdit;
    } else {
      this.Movimiento = new MembresiasMovimientos();
      if (this.membresia) {
        this.Movimiento.Membresia = this.membresia;
      }
      this.Movimiento.Cantidad.M = this.currencyClass.getCurrencyDefault();
    }
  },
};
</script>
<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>
